import { registerComponent, getComponentConfig } from "helpers";

registerComponent(
  "hover-intent",
  class HoverIntent extends HTMLElement {
    DEFAULT_CONFIG = {
      activeClass: "nav-item--expanded",
      mouseEnterDelay: 100,
      mouseExitDelay: 400,
      mouseSensitivity: 7,
    };

    connectedCallback() {
      this.config = getComponentConfig(this);
      this.elements = this.querySelectorAll("[data-hover-intent-item]");
      this.optionsID = this.dataset.hoverIntent;
      this.previousPageX = 0;
      this.previousPageY = 0;
      this.currentPageX = 0;
      this.currentPageY = 0;

      this.elements.forEach((element) => {
        const menu = element.querySelector("[data-menu]");

        if (!menu) {
          return;
        }

        element.mouseEnterDelay = undefined;
        element.mouseExitDelay = undefined;

        element.isActive = false;
        element.addEventListener(
          "mouseenter",
          this.handleMouseEnter.bind(this)
        );
        element.addEventListener(
          "mouseleave",
          this.handleMouseLeave.bind(this)
        );
      });

      this.addEventListener("mousemove", this.trackMouseMove);
    }

    trackMouseMove(event) {
      this.currentPageX = event.pageX;
      this.currentPageY = event.pageY;
    }

    handleMouseEnter(event) {
      const element = event.currentTarget;
      if (element.isActive) {
        clearTimeout(element.mouseExitDelay);
        return;
      }

      this.previousPageX = this.currentPageX;
      this.previousPageY = this.currentPageY;

      element.mouseEnterDelay = setTimeout(() => {
        this.compareMousePosition(element);
      }, this.config.mouseEnterDelay);
    }

    handleMouseLeave(event) {
      const element = event.currentTarget;
      clearTimeout(element.mouseEnterDelay);

      if (!element.isActive) {
        return;
      }

      element.mouseExitDelay = setTimeout(() => {
        this.removeActiveClass(element);
        element.isActive = false;
      }, this.config.mouseExitDelay);
    }

    compareMousePosition(element) {
      const distanceX = this.previousPageX - this.currentPageX;
      const distanceY = this.previousPageY - this.currentPageY;
      const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

      if (distance < this.config.mouseSensitivity) {
        clearTimeout(element.mouseExitDelay);
        element.isActive = true;
        this.addActiveClass(element);
      } else {
        this.previousPageX = this.currentPageX;
        this.previousPageY = this.currentPageY;
        element.mouseEnterDelay = setTimeout(() => {
          this.compareMousePosition(element);
        }, this.config.mouseEnterDelay);
      }
    }

    addActiveClass(element) {
      const item = element.querySelector("nav-item");
      item.setAttribute("expanded", true);
      element.classList.add(this.config.activeClass);
    }

    removeActiveClass(element) {
      const item = element.querySelector("nav-item");
      item.setAttribute("expanded", false);
      element.classList.remove(this.config.activeClass);
    }
  }
);
